// const buttons = document.querySelectorAll('[data-behaviour="toggle-accordion"]');
// //only toggles
// buttons.forEach(button => {
// 	button.addEventListener('click', function () {
// 		let parent = button.closest('[data-ref="accordion"]');
// 		let classToSet = parent.dataset.class + '--open';
// 		parent.classList.toggle(classToSet);
// 	});
// });
const buttons = document.querySelectorAll('[data-behaviour="toggle-accordion"]');

buttons.forEach(button => {
    button.addEventListener('click', function () {
        let parent = button.closest('[data-ref="accordion"]');
        let classToSet = parent.dataset.class + '--open';

        const wasAlreadyOpen = parent.classList.contains(classToSet);

        buttons.forEach(innerButton => {
            let innerParent = innerButton.closest('[data-ref="accordion"]');
            innerParent.classList.remove(innerParent.dataset.class + '--open');
        });

        if (!wasAlreadyOpen) {
            parent.classList.add(classToSet);
        }

        button.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
});